import React from "react";
import useFadeIn from "../hooks/useFadeIn";
import elBahr from "../media/logos/elBa7r-logo.png";
import hybrid from "../media/logos/hybrid-logo.png";
import flySurf from "../media/logos/fly-surf-logo.png";
import "./VenueCard.scss";

// links: { instagram, facebook, location, menu }, add only the ones available
const venues = [
  {
    name: "El Bahr",
    image: elBahr,
    links: {
      instagram: "https://www.instagram.com/elbahr.elgouna?igsh=YmhqejRsMWVtdzR5",
      facebook: "https://www.facebook.com/share/G2SL73Ssec9V7Rd4/?mibextid=LQQJ4d",
      location:
        "https://www.google.com/maps/place/El+Bahr+Seafood+Restaurant,+Kite+Center+Rd,+Hurghada+2,+Red+Sea+Governorate+1982710,+Egypt/@27.4184692,33.6738604,18z/data=!4m6!3m5!1s0x1452677b6b2d1551:0xc2ca1973b2519220!8m2!3d27.4182777!4d33.6748008!16s%2Fg%2F11g0kf6s1w",
    },
  },
  {
    name: "Hybrid",
    image: hybrid,
    links: {
      instagram: "https://www.instagram.com/hybridelgouna?igsh=emdqaHk4cHBndWRs",
    },
  },
  {
    name: "FlySurf Pro",
    image: flySurf,
    links: {
      instagram: "https://www.instagram.com/flysurfpro?igsh=ZjFvaTNhZjRrajU2",
    },
  },
];

const linkConfig = [
  { key: "instagram", icon: "fa-brands fa-instagram", label: "Instagram" },
  { key: "facebook",  icon: "fa-brands fa-facebook",  label: "Facebook" },
  { key: "location",  icon: "fa-solid fa-location-dot", label: "Location" },
  { key: "menu",      icon: "fa-solid fa-utensils",    label: "Menu" },
];

function VenueItem({ venue, index }) {
  const ref = useFadeIn(index * 100);
  return (
    <div ref={ref} className="venue fade-in">
      <div className="image-container">
        <img src={venue.image} alt={venue.name} loading="lazy" />
      </div>
      <div className="venue-links">
        {linkConfig
          .filter(({ key }) => venue.links[key])
          .map(({ key, icon, label }) => (
            <a
              key={key}
              href={venue.links[key]}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={label}
            >
              <i className={icon}></i>
            </a>
          ))}
      </div>
    </div>
  );
}

const VenueCard = () => {
  return (
    <div className="venue-container">
      <div className="venue-container-inner">
        {venues.map((venue, i) => (
          <VenueItem venue={venue} index={i} key={venue.name} />
        ))}
      </div>
    </div>
  );
};

export default VenueCard;
